export default __webpack_public_path__ + "static/moto-02515bb1759810de3754fc8318501b05.png";